const mvSwiper = new Swiper('.mv-swiper', {
    // Optional parameters
    loop: true,
    effect: 'fade',
    slidesPerView: 1,
    spaceBetween: 0,
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
